import ChatbotWrapper from "../../../atoms/wrapper/chatbotWrapper.styled";
import React from "react";
import RenderChat from "../../../page/renderChat/renderChat";
import WelcomePage from "../../../page/welcomePage/welcomePage";
import { AppContext } from "../../../../store/genesys.context";
import NavbarContainer from "../../navbar/navbar";
import DataProtectionNotice from "../../welcomePage/dataProtectionNotice";
import RateChat from "../rateChat/rateChat";

const MaximizedChat = ({
  ref,
}: {
  ref?: React.Ref<HTMLDivElement>;
}): React.JSX.Element => {
  const {
    minimizeBot,
    openChat,
    acceptDataProtectionNotice,
    rateChat,
  }: {
    minimizeBot: boolean;
    openChat: boolean;
    acceptDataProtectionNotice: boolean;
    rateChat: boolean;
  } = React.useContext(AppContext);

  return (
    <ChatbotWrapper
      ref={ref} // A11Y FIX: focus target when the chat window opens
      tabIndex={-1} // A11Y FIX: programmatically focusable (not in tab order)
      minimizeBot={minimizeBot}
      role="region" // A11Y FIX
      aria-label="Chatfenster" // A11Y FIX
    >
      <NavbarContainer />
      {rateChat && <RateChat />}
      {!rateChat && !openChat && <WelcomePage />}
      {!rateChat && openChat && !acceptDataProtectionNotice && (
        <DataProtectionNotice />
      )}
      {!rateChat && openChat && acceptDataProtectionNotice && <RenderChat />}
    </ChatbotWrapper>
  );
};
export default MaximizedChat;
